import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Role } from '@shared/types';

/** 认证状态中存储的用户信息 */
interface AuthUser {
  id: number;
  username: string;
  real_name: string;
  role: Role;
  agent_level?: number | null;
  parent_id?: number | null;
  phone?: string;
  card_segment?: string;
  status?: string;
  /**
   * 利润可见性（2026-09-08）：后端登录响应下发
   * admin / 一级 / 二级 = true；三级 = false；undefined 一律视为 false（保守拒绝，K4）
   */
  profit_visible?: boolean;
}

/** 认证状态Store */
interface AuthState {
  /** JWT Token */
  token: string | null;
  /** 当前用户信息 */
  user: AuthUser | null;
  /** 设置Token */
  setToken: (token: string | null) => void;
  /** 设置用户信息 */
  setUser: (user: AuthUser | null) => void;
  /** 清除认证状态 */
  clearAuth: () => void;
}

/**
 * zustand 认证状态管理
 * 使用 persist 中间件持久化到 localStorage
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: localStorage.getItem('token'),
      user: (() => {
        try {
          const stored = localStorage.getItem('user');
          return stored ? JSON.parse(stored) : null;
        } catch {
          return null;
        }
      })(),
      setToken: (token) => set({ token }),
      setUser: (user) => set({ user }),
      clearAuth: () => set({ token: null, user: null }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ token: state.token, user: state.user }),
    },
  ),
);
